module.exports = __webpack_public_path__ + "static/img/science1.014c6779.png";